'use client';

import { useSoundContext } from '@/context/SoundContext';

/**
 * Convenience hook for sound system access.
 * Wraps SoundContext for easy destructuring in components.
 */
export function useSound() {
  return useSoundContext();
}

export default useSound;
